import {Injectable} from '@angular/core';
import { Headers, Response, URLSearchParams, RequestOptions } from '@angular/http';
import {HttpAuth} from './http-auth.service';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import 'rxjs/add/operator/map';

@Injectable()
export class RequisitionService {

  private requisitionUrl: string;
  private contractUrl: string;
  private qaUrl: string;
  private qaUnanswerUrl: string;
  private reqNoFreelancer: string;
  
  constructor(private http: HttpAuth) {
    this.requisitionUrl = `${ environment.apiRoot }/requisition/`;
    this.contractUrl = `${ environment.apiRoot }/contract/`;
    this.qaUrl = `${ environment.apiRoot }/q-a/`;
    this.qaUnanswerUrl = `${ environment.apiRoot }/job-q-a/`;
    this.reqNoFreelancer = `${ environment.apiRoot }/req-no-freelancer/`;
  }

  public getRequisition(id: string): Observable<any> {
    const params: URLSearchParams = new URLSearchParams();

    params.append('id', String(id));

    const options = new RequestOptions({search: params});

    return this.http.get(this.requisitionUrl, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public getReq(report, page?: number, pagecount?: number): Observable<any> {
    const params: URLSearchParams = new URLSearchParams();
    params.append('report', String(report));
    if (page != null) {
      params.append('page', String(page));
    }

    if(pagecount) {
      params.append('pagecount', String(pagecount));
    }

    const options = new RequestOptions({search: params});

    return this.http.get(this.requisitionUrl, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public getReqNoFreelancer(page?: number, pagecount?: number): Observable<any> {
    const params: URLSearchParams = new URLSearchParams();
    if (page != null) {
      params.append('page', String(page));
    }

    if(pagecount) {
      params.append('pagecount', String(pagecount));
    }

    const options = new RequestOptions({search: params});

    return this.http.get(this.reqNoFreelancer, options)
      .map(this.extractData)
      .catch(this.handleError);
  }
  
  public getContract(page?: number, pagecount?: number): Observable<any> {
    const params: URLSearchParams = new URLSearchParams();
    if (page != null) {
      params.append('page', String(page));
    }

    if(pagecount) {
      params.append('pagecount', String(pagecount));
    }

    const options = new RequestOptions({search: params});
    
    return this.http.get(this.contractUrl, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public getContractById(id): Observable<any> {
    const params: URLSearchParams = new URLSearchParams();
    params.append('contract_id', String(id));
    const options = new RequestOptions({search: params});

    return this.http.get(this.contractUrl, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public getContractNew(report, page?: number, pagecount?: number): Observable<any> {
    const params: URLSearchParams = new URLSearchParams();
    params.append('status', String(report));
    if (page != null) {
      params.append('page', String(page));
    }

    if(pagecount) {
      params.append('pagecount', String(pagecount));
    }

    const options = new RequestOptions({search: params});

    return this.http.get(this.contractUrl, options)
      .map(this.extractData)
      .catch(this.handleError);
  }
  
  public putContractStatus(id, status): Observable<any> {
    const params: URLSearchParams = new URLSearchParams();
    const body = {id: id, status: status};

    const options = new RequestOptions({search: params});

    return this.http.put(this.contractUrl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public putRequisitionStatus(id, status): Observable<any> {
    const params: URLSearchParams = new URLSearchParams();
    const body = {id: id, status: status};

    const options = new RequestOptions({search: params});

    return this.http.put(this.requisitionUrl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public putRequisitionNotes(id, notes): Observable<any> {
    const params: URLSearchParams = new URLSearchParams();
    const body = {id: id, notes: notes};

    const options = new RequestOptions({search: params});

    return this.http.put(this.requisitionUrl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }
  
  public getQa(job_id): Observable<any> {
    const params: URLSearchParams = new URLSearchParams();

    params.append('job_id', String(job_id));

    const options = new RequestOptions({search: params});

    return this.http.get(this.qaUrl, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public getQaUnanswer(page?: number, pagecount?: number): Observable<any> {
    const params: URLSearchParams = new URLSearchParams();
    params.append('filter', String(1));
    if (page != null) {
      params.append('page', String(page));
    }

    if(pagecount) {
      params.append('pagecount', String(pagecount));
    }

    const options = new RequestOptions({search: params});

    return this.http.get(this.qaUnanswerUrl, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public postRequisition(requisition: any): Observable<any> {
    const params: URLSearchParams = new URLSearchParams();

    const options = new RequestOptions({search: params});

    return this.http.post(this.requisitionUrl, requisition, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public putRequisition(requisition: any): Observable<any> {
    const params: URLSearchParams = new URLSearchParams();

    const options = new RequestOptions({search: params});

    return this.http.put(this.requisitionUrl, requisition, options)
      .map(this.extractData)
      .catch(this.handleError);
  }
  
  public putQuestionAnswer(id, answer): Observable<any> {
    let params: URLSearchParams = new URLSearchParams();
    const body = {'id': id, 'answer': answer};

    let options = new RequestOptions({search: params});

    return this.http.put(this.qaUrl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  //noinspection JSMethodCanBeStatic
  private extractData(res: Response) {
    const body = res.json();
    return body.data || {};
  }

  //noinspection JSMethodCanBeStatic
  private handleError(error: Response | any) {
    let errMsg: string;

    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.meta && body.meta.message || JSON.stringify(body);
      errMsg = `${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }

    console.error(errMsg);

    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// /Users/everis/code/Dj/front.staff/src/app/services/requisition.service.ts